import styled from "styled-components";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";

export const ModalPrimaryContent = styled(Text)`
  color: #121212;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const ModalSecondaryContent = styled(Text)`
  color: var(--Neutral-N500, #36354c);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 16px;
`;

export const ZdTable = styled.div`
  width: 100%;
  border: 1px solid #e7e7f0;
  border-radius: 8px;
  overflow: hidden;
  margin: 16px 0;
  min-width: 0;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
`;

export const ZdItem = styled.div<{
  background?: string;
  isTitle?: boolean;
  isFeature?: boolean;
  isSecondColumn?: boolean;
}>`
  flex: ${(props) => (props.isFeature ? "2 1 0" : props.isSecondColumn ? "1 1 0" : "1 1 0")};
  min-width: 0;
  padding: 10px 12px;
  border-right: 1px solid #e7e7f0;
  background: ${(props) => props.background || "white"};
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 12px;
  line-height: 18px;
  color: #121212;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
  }

  ${(props) =>
    props.isTitle &&
    !props.isSecondColumn &&
    `
    background: #F8F7FC;
    font-weight: 600;
  `}

  ${(props) =>
    props.isTitle &&
    props.isSecondColumn &&
    `
    background: #FBE9F6;
    font-weight: 600;
    text-align: center;
  `}
  
  ${(props) =>
    props.isFeature &&
    `
    text-align: left;
  `}
  
  ${(props) =>
    !props.isTitle &&
    !props.isFeature &&
    props.isSecondColumn &&
    `
    background: var(--Maroon-M50, #FBE9F6);
    font-weight: 500;
  `}
  
  ${(props) =>
    !props.isTitle &&
    !props.isFeature &&
    !props.isSecondColumn &&
    `
    font-weight: 500;
  `}
`;

export const ZdExampleCard = styled.div`
  border: 1px solid #e7e7f0;
  border-radius: 8px;
  margin-top: 16px;
  overflow: hidden;
`;

export const RecommendedTag = styled.div`
  display: flex;
  width: 110px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  border: 1.4px solid #fff;
  background: #fbe9f6;
  position: absolute;
  left: 60.5%;
  transform: translateX(-50%);
  z-index: 10;

  @media (max-width: 768px) {
    left: 60%;
    width: 88px;
    transform: translateX(-50%);
  }
`;

export const RecommendedText = styled.span`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  letter-spacing: -0.1px;
  background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const ExampleDescription = styled.div`
  color: var(--Neutral-N500, #36354c);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const ModalContentWrapper = styled.div<{ isDesktop?: boolean }>`
  padding: ${(props) => (props.isDesktop ? "0px 2rem" : "0px 1.25rem")};
  margin-top: -9px;
`;

export const DescriptionWrapper = styled(ModalSecondaryContent)`
  margin-bottom: 1rem;
`;

export const TableContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const TableWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`;

export const ExampleTitle = styled(ModalPrimaryContent)`
  margin: 1rem 0px;
`;

export const RepairCostBox = styled(Box)`
  padding: 16px 12px 12px 12px;
  background-color: #f8f7fc;
  width: auto;
`;

export const RepairCostTitle = styled(ModalPrimaryContent)`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const DepreciationNote = styled(ModalSecondaryContent)`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;

export const ComparisonRow = styled(Flex)`
  gap: 0.5rem;
  align-items: start;
  padding: 16px 12px 12px 12px;
  width: auto;
`;

export const ComparisonRowWithBorder = styled(ComparisonRow)`
  border-bottom: 1px solid #e7e7f0;
`;

export const IconWrapper = styled.div`
  min-width: 22px;
`;

export const ComparisonContent = styled.div``;

export const ComparisonTitle = styled(ModalPrimaryContent)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const ComparisonDescription = styled(ModalSecondaryContent)`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--text-secondary-n-400, #5B5675);
`;
